var _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgControls = function SvgControls(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 93 80"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 30,
    x: 25.5,
    y: 10,
    fill: "currentColor",
    rx: 3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 19.5,
    height: 6,
    y: 22,
    fill: "currentColor",
    opacity: 0.4,
    rx: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 49.5,
    height: 6,
    x: 43.5,
    y: 22,
    fill: "currentColor",
    opacity: 0.4,
    rx: 1.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 30,
    x: 67.5,
    y: 70,
    fill: "currentColor",
    rx: 3,
    transform: "rotate(-180 67.5 70)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 19.5,
    height: 6,
    x: 93,
    y: 58,
    fill: "currentColor",
    opacity: 0.4,
    rx: 1.5,
    transform: "rotate(-180 93 58)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 49.5,
    height: 6,
    x: 49.5,
    y: 58,
    fill: "currentColor",
    opacity: 0.4,
    rx: 1.5,
    transform: "rotate(-180 49.5 58)"
  })));
};
export default SvgControls;